import { render, staticRenderFns } from "./googleAdsIput.vue?vue&type=template&id=0527e9cd&scoped=true"
import script from "./googleAdsIput.vue?vue&type=script&lang=js"
export * from "./googleAdsIput.vue?vue&type=script&lang=js"
import style0 from "./googleAdsIput.vue?vue&type=style&index=0&id=0527e9cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0527e9cd",
  null
  
)

export default component.exports